import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Credentialed client so the httpOnly session cookie is sent with owner requests.
export const authClient = axios.create({ baseURL: API, withCredentials: true });

export async function exchangeSession(sessionId) {
  const { data } = await authClient.post("/auth/session", null, {
    headers: { "X-Session-ID": sessionId },
  });
  return data;
}

export async function getMe() {
  const { data } = await authClient.get("/auth/me");
  return data;
}

export async function logout() {
  await authClient.post("/auth/logout");
}
